// @flow
import React from 'react';

import Emojify from 'app/components/shared/Emojify';
import FriendlyTime from 'app/components/shared/FriendlyTime';
import UserAvatar, { type JobPresenterUser } from 'app/components/shared/UserAvatar';

import BlockFieldsModal from 'app/components/job/BlockFieldsModal';

type Props = {
  job: {
    name: ?string,
    state: string,
    activatePath?: string,
    prompt?: string,
    fields: ?Array<Object>,
    unblockedAt?: string,
    unblockedBy: ?JobPresenterUser,
    permissions: {
      activate: {
        allowed: boolean
      }
    }
  }
};

type State = {
  fieldsModalActivated: boolean
};

export default class ManualJobSummary extends React.PureComponent<Props, State> {
  state = {
    fieldsModalActivated: false
  };

  fieldsModal: ?BlockFieldsModal;

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.fieldsModal && prevState.fieldsModalActivated !== this.state.fieldsModalActivated) {
      this.fieldsModal.show();
    }
  }

  renderSummary() {
    if (this.props.job.unblockedAt && this.props.job.unblockedBy) {
      return (
        <div className="build-details-pipeline-manual-job">
          <span className="unblocked">
            <UserAvatar
              user={UserAvatar.convertUserFromJobPresenter(this.props.job.unblockedBy)}
              style={{ width: 24, height: 24, marginRight: 6 }}
            />
            <strong className="semi-bold">
              {this.props.job.unblockedBy && this.props.job.unblockedBy.name}
            </strong>
            {" unblocked "}
            <strong className="semi-bold">
              <Emojify text={this.props.job.name || "Continue"} />
            </strong>
            {this.unblockedAtNode()}
          </span>
        </div>
      );
    } else if (!this.props.job.permissions.activate.allowed) {
      return (
        <div className="build-details-pipeline-manual-job">
          <button className="twbs-btn twbs-btn-default twbs-btn-disabled" disabled={true}>
            <i className="fa fa-lock" />
            <strong className="semi-bold">
              <Emojify text={this.props.job.name || "Continue"} />
            </strong>
          </button>
        </div>
      );
    } else if ((this.props.job.state === "skipped") || (this.props.job.state === "canceled") || (this.props.job.state === "blocked_failed")) {
      return (
        <div className="build-details-pipeline-manual-job">
          <button
            href={this.props.job.activatePath}
            className="twbs-btn twbs-btn-default twbs-btn-disabled"
            disabled={true}
          >
            <i className="fa fa-lock" />
            <strong className="semi-bold">
              <Emojify text={this.props.job.name || "Continue"} />
            </strong>
          </button>
        </div>
      );
    }

    if (this.props.job.fields) {
      return (
        <div className="build-details-pipeline-manual-job">
          <a
            href="#"
            className="twbs-btn twbs-btn-default"
            onClick={this.handleContinueButtonClick}
          >
            <i className="fa fa-lock" />
            <strong className="semi-bold">
              <Emojify text={this.props.job.name || "Continue"} />
            </strong>
          </a>
        </div>
      );
    }

    return (
      <div className="build-details-pipeline-manual-job">
        <a
          href={this.props.job.activatePath}
          className="twbs-btn twbs-btn-default"
          data-remote="true"
          data-confirm={this.props.job.prompt || "Unblock this step?"}
          data-method="post"
        >
          <i className="fa fa-lock" />
          <strong className="semi-bold">
            <Emojify text={this.props.job.name || "Continue"} />
          </strong>
        </a>
      </div>
    );
  }

  handleContinueButtonClick = (evt: MouseEvent) => {
    evt.preventDefault();
    if (this.state.fieldsModalActivated) {
      if (this.fieldsModal) {
        this.fieldsModal.show();
      }
    } else {
      this.setState({
        fieldsModalActivated: true
      });
    }
  };

  unblockedAtNode() {
    if (this.props.job.unblockedAt) {
      return (
        <small className="text-muted">
          <br />
          {" "}
          <FriendlyTime
            value={this.props.job.unblockedAt}
            capitalized={true}
          />
        </small>
      );
    }
  }

  render() {
    const fieldsModal = this.state.fieldsModalActivated && (
      <BlockFieldsModal
        ref={(fieldsModal) => this.fieldsModal = fieldsModal}
        job={this.props.job}
      />
    );

    return (
      <div>
        {fieldsModal}
        {this.renderSummary()}
      </div>
    );
  }
}
